<template>
  <div class="box">
    <h2>短网址</h2>
    <input class="longUrl" type="text" v-model="longUrl">
    <button class="shorten"  @click="shorten">缩短</button>
    <br/>
    <br/>
    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "Dwz",
  data() {
    return {
      dwz: "",
      longUrl: ""
    }  
  },
  methods: {
    async shorten(){

      const res = await axios.get('http://egg.dingjian.name/dwz?long_url=' + this.longUrl)
      
      console.log(res);
      this.copy(res.data.shorturl.split("//")[1])
      alert(`链接已复制:${res.data.shorturl.split("//")[1]}`);
    },
    copy(txet) {
      let transfer = document.createElement('input');
      document.body.appendChild(transfer);
      transfer.value = txet;  // 这里表示想要复制的内容
      transfer.focus();
      transfer.select();
      if (document.execCommand('copy')) {
          document.execCommand('copy');
      }
      transfer.blur();
      console.log('复制成功');
      document.body.removeChild(transfer);
    }
  },
  
}
</script>
<style scoped>
  .box {
    width: 100%;
    padding: 10px;
    text-align: center;
  }
  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  .longUrl {
    width: 80%;
    height: 40px;
    border-radius: 5px;
  }
  .shorten{
    height: 40px;
    width: 50px;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/view/dwz/index.vue